export enum OrderViewEnum {
    list, cards, location
}